module.exports = __webpack_public_path__ + "e4b2be9dc3a6efbd832b3c9de2bf92e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/13.jpg
// module id = 1339
// module chunks = 47